// extracted by mini-css-extract-plugin
export default {"container":"flightTypeSidebar-module__container__cW80y"};